// extracted by mini-css-extract-plugin
export default {"forgotPassword":"forgot-password_forgotPassword__Y6naO","logo":"forgot-password_logo__06ohw","container":"forgot-password_container__TGijS","form":"forgot-password_form__y+JQg"};